import React from 'react';
import PropTypes from 'prop-types';
import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { AppraisalLazyLoadDrawerLoadingPlaceholder } from 'site-modules/shared/components/appraisal/appraisal-lazy-load-drawer-loading-placeholder/appraisal-lazy-load-drawer-loading-placeholder';

const LoadingComponent = ({ lazyLoadingPlaceholderBackButtonSlot }) => (
  <AppraisalLazyLoadDrawerLoadingPlaceholder backButtonSlot={lazyLoadingPlaceholderBackButtonSlot} />
);

LoadingComponent.propTypes = {
  lazyLoadingPlaceholderBackButtonSlot: PropTypes.node.isRequired,
};

export const FindStyleDrawerContentAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "find-style-drawer-content" */ './find-style-drawer-content'),
  componentName: 'FindStyleDrawerContent',
  loading: LoadingComponent,
});
